import { PipeTransform, Pipe } from '@angular/core';
import * as d3 from 'd3';
import { RoutingService } from '../service/routing.service';
import { SCORE_SCALE_DARK, SCORE_SCALE_LIGHT } from './score-colors';

/**
 * This pipe define the color of the trend inside the chartpmap component
 */
@Pipe({ name: 'colorTrend' })
export class ColorTrendPipe implements PipeTransform {
  constructor(public routing: RoutingService) {}
  transform(value: number): string {
    const ivalue = Math.round(value * 100) / 100;
    if (ivalue < 0) {
      value = 0;
    }
    if (ivalue === 0) {
      value = 0.5;
    }
    if (ivalue > 0) {
      value = 1;
    }
    const colors =
      this.routing.theme === 'light' ? SCORE_SCALE_LIGHT : SCORE_SCALE_DARK;
    const colorScale = d3
      .scaleLinear<string>()
      .domain([0, 0.5, 1])
      .range(colors);
    return colorScale(value).toString();
  }
}
